import React, { useEffect, useState } from 'react';
import { getCountdownParts } from '../../data/flashSale/campaignHelpers';

/**
 * Countdown tied to a fixed ISO expiration. Resets only when the deadline changes,
 * not on refresh (deadline is server/config time, not client-local duration).
 */
export default function FlashSaleCountdown({
  endsAt,
  className = '',
  onExpire,
  label = 'Offer ends in',
}) {
  const [parts, setParts] = useState(() => getCountdownParts(endsAt));

  useEffect(() => {
    setParts(getCountdownParts(endsAt));
    const id = window.setInterval(() => {
      const next = getCountdownParts(endsAt);
      setParts(next);
      if (next.expired) {
        window.clearInterval(id);
        onExpire?.();
      }
    }, 1000);
    return () => window.clearInterval(id);
  }, [endsAt, onExpire]);

  if (!endsAt) return null;

  if (parts.expired) {
    return (
      <div className={`fs-countdown fs-countdown--expired ${className}`.trim()} role="status">
        <span className="fs-countdown__label">Offer ended</span>
      </div>
    );
  }

  const units = [
    { key: 'days', value: parts.days, label: 'Days' },
    { key: 'hours', value: parts.hours, label: 'Hours' },
    { key: 'minutes', value: parts.minutes, label: 'Min' },
    { key: 'seconds', value: parts.seconds, label: 'Sec' },
  ];

  return (
    <div
      className={`fs-countdown ${className}`.trim()}
      role="timer"
      aria-live="polite"
      aria-atomic="true"
      aria-label={`${label}: ${parts.days} days, ${parts.hours} hours, ${parts.minutes} minutes, ${parts.seconds} seconds`}
    >
      <span className="fs-countdown__label">{label}</span>
      <div className="fs-countdown__units">
        {units.map((u) => (
          <div key={u.key} className="fs-countdown__unit">
            <span className="fs-countdown__value">
              {String(u.value).padStart(2, '0')}
            </span>
            <span className="fs-countdown__unit-label">{u.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
